import {BaseCachedService} from './Core/BaseCachedService';

class PermitTypeService extends BaseCachedService {
    get Url() { return super.Url + "/permitTypes"; }
    get ModelName() { return "PermitType"; }
    get PrimaryKeyProperty() { return "permitTypeId"; }
    get TitleProperty() { return "name"; }
    GetSubtitle(model) {
        return model?.PermitOrganization?.name ?? "";
    }
}

export const service = new PermitTypeService();

